/**
 * Focuses the first likely tab-stop inside a container after UI is disclosed (e.g. tab cards).
 * Includes `[tabindex="0"]` to capture MUI Select's inner trigger div, which is
 * focusable via tabIndex but does not carry role="combobox" on the focusable child.
 */
export function focusFirstFocusable(container: Element | null | undefined): void {
  if (!container) {
    return;
  }
  const selector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[role="combobox"]:not([aria-disabled="true"])',
    '[tabindex="0"]',
  ].join(', ');
  container.querySelector<HTMLElement>(selector)?.focus();
}
